import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

/*
  Pantalla que ve el estudiante cuando vuelve de aprobar el pago en
  PayPal. La activacion real del plan la hace el webhook de PayPal en el
  backend (puede tardar unos segundos en llegar), asi que aqui solo
  preguntamos cada pocos segundos si ya quedo activo.
*/
export default function ConfirmandoPago({ usuario, onListo }) {
  const [estado, setEstado] = useState('confirmando') // confirmando | aprobado | error
  const [error,  setError]  = useState('')

  useEffect(() => {
    if (!usuario?.id) return
    let cancelado = false
    let intentos = 0

    async function ciclo() {
      if (cancelado) return
      intentos++
      try {
        const res = await axios.get(`${API}/pagos/estado/${usuario.id}`)
        if (cancelado) return
        if (res.data?.datos?.suscripcion_estado === 'activa') {
          setEstado('aprobado')
          return
        }
      } catch (err) {
        // seguimos intentando en el siguiente ciclo
      }
      if (intentos >= 20) { // ~60 segundos
        setError('Todavia no confirmamos tu pago. Si ya pagaste, dale un momento y vuelve a entrar mas tarde.')
        setEstado('error')
        return
      }
      setTimeout(ciclo, 3000)
    }
    ciclo()

    return () => { cancelado = true }
  }, [usuario])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(145deg, #0a1628 0%, #0f2347 40%, #1a1248 70%, #0d1f3c 100%)',
      fontFamily: 'system-ui, sans-serif',
      padding: 20
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: 420,
        width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {estado === 'confirmando' && (
          <>
            <div style={{ fontSize: 56, marginBottom: 16 }}>⏳</div>
            <h1 style={{ fontSize: 21, fontWeight: 800, color: '#1B3A8C', marginBottom: 10 }}>
              Confirmando tu pago con PayPal...
            </h1>
            <p style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6 }}>
              Esto puede tardar unos segundos, no cierres esta ventana.
            </p>
          </>
        )}

        {estado === 'aprobado' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
            <h1 style={{ fontSize: 21, fontWeight: 800, color: '#1B3A8C', marginBottom: 10 }}>
              ¡Pago aprobado!
            </h1>
            <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28, lineHeight: 1.6 }}>
              Tu plan ya esta activo.
            </p>
            <button onClick={onListo}
              style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg, #1B3A8C, #2D5BE3)', color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              Ir a EspañolGo →
            </button>
          </>
        )}

        {estado === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <p style={{ fontSize: 14, color: '#991B1B', marginBottom: 28, lineHeight: 1.6 }}>{error}</p>
            <button onClick={onListo}
              style={{ width: '100%', padding: '14px', background: 'transparent', color: '#1B3A8C', border: '1.5px solid #E2E6F0', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              Ir a EspañolGo →
            </button>
          </>
        )}
      </div>
    </div>
  )
}
